module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAHCAYAAAChv6WsAAAAbElEQVQ4T9XRoQ0CURRE0fNDkIhVSBSSAtZi6QBPAdSBpgYMCWILHAL5KwgUwLsVzMm0JEdsFa4lGXDHvqqjvYYnWeKKU0XIGzGX5IwLFpUwH4j+ygE3rKpAvhAdssOETQXIT0SHrPHA+O+QJ70UG2wLtcSFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/divr1.png
// module id = /xZY
// module chunks = 1